import React, { useState } from 'react'
import '../login/login.css'
import { Link, } from 'react-router-dom'
import { Navbar } from 'react-bootstrap'

function Login() {
    const [Username, setUsername] = useState('')
    const [Password, setPassword] = useState('')

    const getUser = (e) => {
        const value = e.target.value
        setUsername(value)
    }
    const getPassword = (e) => {
        const value = e.target.value
        setPassword(value)
    }

    return (
        <div>
            <Navbar expand="lg" className='navbar'>
                <div>
                    <Link to='/' className='brand'>EzStay</Link>
                </div>
            </Navbar>
            <div className='title mt-3'>
                <div className='sub-title'>
                    <h3>Log In and Learn The Report</h3>
                    <p>We provide variant data that you can use it in order <br />
                     to get the better perfomance at sales</p>
                </div>
            </div>
            <div className='kartu'>
                <form>
                    <div class="form-group">
                        <label for="email">Username or Email</label>
                        <input type="text" class="form-control" id="email" aria-describedby="emailHelp" value={Username} onChange={getUser} />
                    </div>
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" class="form-control" id="password" value={Password} onChange={getPassword} />
                    </div>
                    <p className='forgotPass'><a href='#'>Forgot Password</a></p>
                    <button type="submit" class="btn btn-primary">Sign In</button>
                    <p className='createNew'><a href='/signup'>Create New Account</a></p>
                </form>
            </div>
        </div>
    )
}

export default Login
